export const forwardRegDataAllData = [
  {
    hedgeDealRefNo: "HDL20251001",
    outstandingAmount: "125,000",
    deliveryDateFrom: "2025-11-01",
    deliveryDateTo: "2025-12-31",
    hedgeRate: "83.45",
  },
  {
    hedgeDealRefNo: "HDL20251002",
    outstandingAmount: "98,500",
    deliveryDateFrom: "2025-10-15",
    deliveryDateTo: "2025-11-30",
    hedgeRate: "82.90",
  },
  {
    hedgeDealRefNo: "HDL20251003",
    outstandingAmount: "150,000",
    deliveryDateFrom: "2025-12-01",
    deliveryDateTo: "2026-01-15",
    hedgeRate: "84.10",
  },
  {
    hedgeDealRefNo: "HDL20251004",
    outstandingAmount: "210,000",
    deliveryDateFrom: "2025-09-25",
    deliveryDateTo: "2025-10-25",
    hedgeRate: "81.75",
  },
];


export const banks = [
  {
    value: "hdfc",
    label: "HDFC",
  },
  {
    value: "sbi",
    label: "SBI",
  },
  {
    value: "icici",
    label: "ICICI",
  },
]

export const bankSpreadOptions = [
  {
    value: "12-15",
    label: "12-15",
  },
  {
    value: "15-18",
    label: "15-18",
  },
  {
    value: "18-21",
    label: "18-21",
  },
  
]
